export default {
  label: {
    color: "#595959",
    fontSize: "13px",
    fontWeight: "bold",
  },
  strongLabel: {
    color: "#0072ca",
    display: "inline-block",
    fontWeight: "bold",
  },
};
